import { render } from "./FaultknowledgeBase.vue?vue&type=template&id=11ceda60&scoped=true"
import script from "./FaultknowledgeBase.vue?vue&type=script&lang=js"
export * from "./FaultknowledgeBase.vue?vue&type=script&lang=js"

import "./FaultknowledgeBase.vue?vue&type=style&index=0&id=11ceda60&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ceda60"]])

export default __exports__